<template>
  <div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxResponsiveBox :screen-by-width="screen" single-column-screen="sm">
          <!-- ada 3 row, 4 col -->
          <DxRow :ratio="1" />
          <DxRow :ratio="1" />
          <DxRow :ratio="1" />

          <DxCol :ratio="1" />
          <DxCol :ratio="1" />
          <DxCol :ratio="1" />
          <DxCol :ratio="1" />

          <DxItem>
            <DxLocation :row="0" :col="0" :colspan="1" />
            <a href="#">
              <div class="dashboard-card">
                <div
                  class="dx-card"
                  style="
                    margin: 10px;
                    padding: 15px;
                    background-color: rgba(243, 158, 108, 0.8);
                  "
                >
                  <div class="dx-field">
                    <div
                      class="dx-field-value-static"
                      style="font-weight: bold; font-size: 16px"
                    >
                      Kenaikan Gaji Berkala April 2023
                    </div>
                    <div
                      class="dx-field-value-static"
                      style="
                        font-weight: bold;
                        font-size: 40px;
                        color: aliceblue;
                      "
                    >
                      200
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </DxItem>

          <DxItem>
            <DxLocation :row="0" :col="1" :colspan="1" />
            <a href="#">
              <div class="dashboard-card">
                <div
                  class="dx-card"
                  style="
                    margin: 10px;
                    padding: 15px;
                    background-color: rgba(148, 215, 199, 0.8);
                  "
                >
                  <div class="dx-field">
                    <div
                      class="dx-field-value-static"
                      style="font-weight: bold; font-size: 16px"
                    >
                      Kenaikan Pangkat April 2023
                    </div>
                    <div
                      class="dx-field-value-static"
                      style="
                        font-weight: bold;
                        font-size: 40px;
                        color: aliceblue;
                      "
                    >
                      200
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </DxItem>

          <DxItem>
            <DxLocation :row="0" :col="2" :colspan="1" />
            <a href="#">
              <div class="dashboard-card">
                <div
                  class="dx-card"
                  style="
                    margin: 10px;
                    padding: 15px;
                    background-color: rgba(119, 199, 231, 0.8);
                  "
                >
                  <div class="dx-field">
                    <div
                      class="dx-field-value-static"
                      style="font-weight: bold; font-size: 16px"
                    >
                      Pegawai Pensiun Tahun 2023
                    </div>
                    <div
                      class="dx-field-value-static"
                      style="
                        font-weight: bold;
                        font-size: 40px;
                        color: aliceblue;
                      "
                    >
                      200
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </DxItem>

          <DxItem>
            <DxLocation :row="0" :col="3" :colspan="1" />
            <a href="#">
              <div class="dashboard-card">
                <div
                  class="dx-card"
                  style="
                    margin: 10px;
                    padding: 15px;
                    background-color: rgba(123, 155, 207, 0.8);
                  "
                >
                  <div class="dx-field">
                    <div
                      class="dx-field-value-static"
                      style="font-weight: bold; font-size: 16px"
                    >
                      Kenaikan Pangkat April 2023
                    </div>
                    <div
                      class="dx-field-value-static"
                      style="
                        font-weight: bold;
                        font-size: 40px;
                        color: aliceblue;
                      "
                    >
                      200
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </DxItem>
        </DxResponsiveBox>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div class="row row-cols-1 row-cols-md-5 g-4">
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">200</h5>
                  <p class="card-text">Pegawai Aktif</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">500</h5>
                  <p class="card-text">Pegawai Tetap</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">500</h5>
                  <p class="card-text">Pegawai Capeg</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">500</h5>
                  <p class="card-text">Pekerja Kontrak</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">500</h5>
                  <p class="card-text">Pegawai Magang</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">500</h5>
                  <p class="card-text">Pegawai Pensiun</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Laki-Laki</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Perempuan</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Pendidikan SMA</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Pendidikan D1</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Pendidikan D2</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Pendidikan D3</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Pendidikan D4</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <a href="#" class="dashboard-card" style="color: black">
                <div class="card-body">
                  <h5 class="card-title">100</h5>
                  <p class="card-text">Pegawai Pendidikan S1</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-2">
      <div class="col">
        <div class="content-block">
          <div class="dx-card responsive-paddings">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Golongan Ruang"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="content-block">
          <div class="dx-card responsive-paddings">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Pendidikan"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-2">
      <div class="col">
        <div class="content-block">
          <div class="dx-card responsive-paddings">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Usia"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="content-block">
          <div class="dx-card responsive-paddings">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Jabatan"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div
          class="row row-cols-1 row-cols-md-2 align-items-md-center g-5 py-5"
        >
          <!-- <div class="row row-cols-1 row-cols-md-2 g-5 py-5"> -->
          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Golongan Ruang"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>

          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Pendidikan"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>

        <div
          class="row row-cols-1 row-cols-md-2 align-items-md-center g-5 py-5"
        >
          <!-- <div class="row row-cols-1 row-cols-md-2 g-5 py-5"> -->
          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Usia"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>

          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Jabatan"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div
          class="row row-cols-1 row-cols-md-4 align-items-md-center g-5 py-5"
        >
          <!-- <div class="row row-cols-1 row-cols-md-2 g-5 py-5"> -->
          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Golongan Ruang"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>

          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Pendidikan"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>

          <!-- <div class="row row-cols-1 row-cols-md-2 g-5 py-5"> -->
          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Usia"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>

          <div class="col">
            <DxChart
              id="chart"
              :data-source="populationData"
              title="Statistik Jabatan"
            >
              <DxArgumentAxis :tick-interval="10">
                <DxLabel format="decimal" />
              </DxArgumentAxis>
              <DxSeries type="bar" />
              <DxLegend :visible="false" />
            </DxChart>
            <a href="#" class="btn">Lihat Detail</a>
          </div>
        </div>
      </div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div
          class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5"
        >
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#bootstrap"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#cpu-fill"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#calendar3"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#home"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#speedometer2"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#toggles2"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#geo-fill"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
          <div class="col d-flex align-items-start">
            <svg
              class="bi text-body-secondary flex-shrink-0 me-3"
              width="1.75em"
              height="1.75em"
            >
              <use xlink:href="#tools"></use>
            </svg>
            <div>
              <h3 class="fw-bold mb-0 fs-4">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- <div id="chart-demo">
          <DxChart
            :data-source="monthWeather"
            :customize-point="customizePoint"
            title="Temperature in Seattle: October 2017"
          >
            <DxSize :height="420" />
            <DxValueAxis>
              <DxLabel :customize-text="customizeLabelText" :visible="true" />
            </DxValueAxis>
            <DxSeries argument-field="day" value-field="t" type="bar" />
            <DxLegend :visible="false" />
            <DxExport :enabled="true" />
            <DxLoadingIndicator :enabled="true" />
          </DxChart>
          <div class="action">
            <div class="label">Choose a temperature threshold, &deg;C:</div>
            <DxSelectBox
              id="choose-temperature"
              :data-source="temperature"
              :value="2"
              :on-value-changed="changeTemperature"
            />
          </div>
        </div> -->
        <DxChart
          id="chart"
          :data-source="populationData"
          title="World Population by Decade"
        >
          <DxArgumentAxis :tick-interval="10">
            <DxLabel format="decimal" />
          </DxArgumentAxis>
          <DxSeries type="bar" />
          <DxLegend :visible="false" />
        </DxChart>
      </div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div id="page2">
          <div class="b-example-divider"></div>
          <div class="card border-left-primary shadow h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div
                    class="text-xs font-weight-bold text-primary text-uppercase mb-1"
                  >
                    Earnings (Monthly)
                  </div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">
                    $40,000
                  </div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-calendar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="row g-4 py-5 row-cols-1 row-cols-lg-3">
            <div class="feature col">
              <div
                class="feature-icon d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-2 mb-3"
              >
                <svg class="bi" width="1em" height="1em">
                  <use xlink:href="#collection"></use>
                </svg>
              </div>
              <h3 class="fs-2">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
                We'll add onto it with another sentence and probably just keep
                going until we run out of words.
              </p>
              <a href="#" class="icon-link">
                Call to action
                <svg class="bi"><use xlink:href="#chevron-right"></use></svg>
              </a>
            </div>
            <div class="feature col">
              <div
                class="feature-icon d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-2 mb-3"
              >
                <svg class="bi" width="1em" height="1em">
                  <use xlink:href="#people-circle"></use>
                </svg>
              </div>
              <h3 class="fs-2">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
                We'll add onto it with another sentence and probably just keep
                going until we run out of words.
              </p>
              <a href="#" class="icon-link">
                Call to action
                <svg class="bi"><use xlink:href="#chevron-right"></use></svg>
              </a>
            </div>
            <div class="feature col">
              <div
                class="feature-icon d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-2 mb-3"
              >
                <svg class="bi" width="1em" height="1em">
                  <use xlink:href="#toggles2"></use>
                </svg>
              </div>
              <h3 class="fs-2">Featured title</h3>
              <p>
                Paragraph of text beneath the heading to explain the heading.
                We'll add onto it with another sentence and probably just keep
                going until we run out of words.
              </p>
              <a href="#" class="icon-link">
                Call to action
                <svg class="bi"><use xlink:href="#chevron-right"></use></svg>
              </a>
            </div>
          </div>

          <div class="container px-4 py-5" id="custom-cards">
            <h2 class="pb-2 border-bottom">Custom cards</h2>

            <div
              class="row row-cols-1 row-cols-lg-3 align-items-stretch g-4 py-5"
            >
              <div class="col">
                <div
                  class="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 shadow-lg"
                  style="background-image: url('unsplash-photo-1.jpg')"
                >
                  <div
                    class="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1"
                  >
                    <h3 class="pt-5 mt-5 mb-4 display-6 lh-1 fw-bold">
                      Short title, long jacket
                    </h3>
                    <ul class="d-flex list-unstyled mt-auto">
                      <li class="me-auto">
                        <img
                          src="https://github.com/twbs.png"
                          alt="Bootstrap"
                          width="32"
                          height="32"
                          class="rounded-circle border border-white"
                        />
                      </li>
                      <li class="d-flex align-items-center me-3">
                        <svg class="bi me-2" width="1em" height="1em">
                          <use xlink:href="#geo-fill"></use>
                        </svg>
                        <small>Earth</small>
                      </li>
                      <li class="d-flex align-items-center">
                        <svg class="bi me-2" width="1em" height="1em">
                          <use xlink:href="#calendar3"></use>
                        </svg>
                        <small>3d</small>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col">
                <div
                  class="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 shadow-lg"
                  style="background-image: url('unsplash-photo-2.jpg')"
                >
                  <div
                    class="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1"
                  >
                    <h3 class="pt-5 mt-5 mb-4 display-6 lh-1 fw-bold">
                      Much longer title that wraps to multiple lines
                    </h3>
                    <ul class="d-flex list-unstyled mt-auto">
                      <li class="me-auto">
                        <img
                          src="https://github.com/twbs.png"
                          alt="Bootstrap"
                          width="32"
                          height="32"
                          class="rounded-circle border border-white"
                        />
                      </li>
                      <li class="d-flex align-items-center me-3">
                        <svg class="bi me-2" width="1em" height="1em">
                          <use xlink:href="#geo-fill"></use>
                        </svg>
                        <small>Pakistan</small>
                      </li>
                      <li class="d-flex align-items-center">
                        <svg class="bi me-2" width="1em" height="1em">
                          <use xlink:href="#calendar3"></use>
                        </svg>
                        <small>4d</small>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col">
                <div
                  class="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 shadow-lg"
                  style="background-image: url('unsplash-photo-3.jpg')"
                >
                  <div class="d-flex flex-column h-100 p-5 pb-3 text-shadow-1">
                    <h3 class="pt-5 mt-5 mb-4 display-6 lh-1 fw-bold">
                      Another longer title belongs here
                    </h3>
                    <ul class="d-flex list-unstyled mt-auto">
                      <li class="me-auto">
                        <img
                          src="https://github.com/twbs.png"
                          alt="Bootstrap"
                          width="32"
                          height="32"
                          class="rounded-circle border border-white"
                        />
                      </li>
                      <li class="d-flex align-items-center me-3">
                        <svg class="bi me-2" width="1em" height="1em">
                          <use xlink:href="#geo-fill"></use>
                        </svg>
                        <small>California</small>
                      </li>
                      <li class="d-flex align-items-center">
                        <svg class="bi me-2" width="1em" height="1em">
                          <use xlink:href="#calendar3"></use>
                        </svg>
                        <small>5d</small>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 mb-3 mb-sm-0">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Special title treatment</h5>
                  <p class="card-text">
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                  <a href="#" class="btn btn-primary">Go somewhere</a>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Special title treatment</h5>
                  <p class="card-text">
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                  <a href="#" class="btn btn-primary">Go somewhere</a>
                </div>
              </div>
            </div>
          </div>

          <DxResponsiveBox :screen-by-width="screen" single-column-screen="sm">
            <DxRow :ratio="1" />
            <DxRow :ratio="2" />
            <DxRow :ratio="1" />

            <DxCol :ratio="1" />
            <DxCol :ratio="2" screen="lg" />
            <DxCol :ratio="1" />
            <DxItem>
              <DxLocation :row="0" :col="0" :colspan="3" screen="lg" />
              <!-- location row n col refer to coordinat DxRow n DxCol. 
               ada 3 row yang ratio 1,2,1 dan ada 3 col ratio 1 2 1.  -->
              <DxLocation :row="0" :col="0" :colspan="2" screen="sm" />
              <div class="header item">
                <p>row 0, col 0, colspan 2</p>
              </div>
            </DxItem>
            <DxItem>
              <DxLocation :row="1" :col="1" screen="lg" />
              <!-- jika screen adalah lg, col = 1 -->
              <DxLocation :row="1" :col="0" :colspan="2" screen="sm" />
              <!-- jika screen sm, content span 2 col -->
              <div class="content item">
                <p>row 1 col 1 for lg,</p>
              </div>
            </DxItem>
            <DxItem>
              <DxLocation :row="1" :col="0" screen="lg" />
              <DxLocation :row="2" :col="0" screen="sm" />
              <div class="left-side-bar item">
                <p>row 1 col 0</p>
              </div>
            </DxItem>
            <DxItem>
              <DxLocation :row="1" :col="2" screen="lg" />
              <DxLocation :row="2" :col="1" screen="sm" />
              <div class="right-side-bar item">
                <p>row 1 col 2</p>
              </div>
            </DxItem>
            <DxItem>
              <DxLocation :row="2" :col="0" :colspan="3" screen="lg" />
              <DxLocation :row="3" :col="0" :colspan="2" screen="sm" />
              <div class="footer item">
                <p>row 2 col 0 span 3</p>
              </div>
            </DxItem>
          </DxResponsiveBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DxChart, {
//   DxValueAxis,
//   DxLabel,
//   DxLegend,
//   DxExport,
//   DxSeries,
//   DxSize,
//   DxLoadingIndicator,
// } from "devextreme-vue/chart";
import DxChart, {
  DxArgumentAxis,
  DxLegend,
  DxLabel,
  DxSeries,
} from "devextreme-vue/chart";

import { populationData } from "./populationData.js";

// import DxSelectBox from "devextreme-vue/select-box";

// import DataSource from "devextreme/data/data_source";
// import CustomStore from "devextreme/data/custom_store";

const palette = ["#c3a2cc", "#b7b5e0", "#e48cba"];
import {
  DxResponsiveBox,
  DxItem,
  DxLocation,
  DxCol,
  DxRow,
} from "devextreme-vue/responsive-box";

export default {
  components: {
    DxResponsiveBox,
    DxItem,
    DxLocation,
    DxCol,
    DxRow,
    // Button,
    // DxChart,
    // DxValueAxis,
    // DxLabel,
    // DxLegend,
    // DxExport,
    // DxLoadingIndicator,
    // DxSeries,
    // DxSize,

    DxChart,
    DxArgumentAxis,
    DxLabel,
    DxLegend,
    DxSeries,

    // DxSelectBox,
  },
  data() {
    // const paletteIndex = 0;

    // const monthWeather = new DataSource({
    //   store: new CustomStore({
    //     load: () =>
    //       fetch("@/monthWeather.json")
    //         .then((e) => e.json())
    //         .catch(() => {
    //           throw new Error("Data Loading Error");
    //         }),
    //     loadMode: "raw",
    //   }),
    //   filter: ["t", ">", "2"],
    //   paginate: false,
    // });

    return {
      populationData,
      temperature: [2, 4, 6, 8, 9, 10, 11],
      // monthWeather,
      // paletteIndex,
      screen(width) {
        return width < 700 ? "sm" : "lg";
      },
    };
  },
  methods: {
    changeTemperature({ value }) {
      this.monthWeather.filter(["t", ">", value]);
      this.monthWeather.load();
    },
    customizeLabelText({ valueText }) {
      return `${valueText}${"&#176C"}`;
    },
    customizePoint() {
      const color = palette[this.paletteIndex];
      this.paletteIndex = this.paletteIndex === 2 ? 0 : this.paletteIndex + 1;

      return { color };
    },
  },
};
</script>

<style>
#chart {
  height: 440px;
}
.action {
  width: 330px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.action .dx-selectbox {
  width: 90px;
}

a.dashboard-card {
  text-decoration: none;
  color: darkred;
}

.dashboard-card {
  text-decoration: none;
  color: darkred;
}

.dashboard-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); /* add a box-shadow when hovered over */
  /* text-decoration: none;
  color: inherit; */
}

.demo-container,
#app,
#page {
  height: 100%;
  min-height: 300px;
}

.header {
  /* background-color: rgba(243, 158, 108, 0.8); */
  text-align: center;
}

.content {
  /* background-color: rgba(245, 229, 166, 0.8); */
}

.left-side-bar {
  background-color: rgba(148, 215, 199, 0.8);
}

.right-side-bar {
  background-color: rgba(119, 199, 231, 0.8);
}

.item {
  height: 100%;
}

#page p {
  font-size: 20px;
  padding-top: 10px;
  text-align: center;
}
</style>
